import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUserAccount, StateStatus, stateIsLoaded } from '@guryou/redux';

const normalizeLanguage = lang =>
  String(lang || '')
    .toLowerCase()
    .startsWith('en')
    ? 'en'
    : 'it';

const UserLanguageSync = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const auth = useSelector(state => state.auth);
  const currentUser = useSelector(state => state.user?.current);
  const isLoggedIn = stateIsLoaded(auth) && !!auth?.data?.userId;
  const userId = auth?.data?.userId;
  const currentUserStatus = currentUser?.status;
  const profileLanguage = currentUser?.data?.userLanguage;
  const cognitoLocale = auth?.data?.locale;
  const lastFetchedUserIdRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn) {
      lastFetchedUserIdRef.current = null;
      return;
    }
    if (lastFetchedUserIdRef.current === userId) {
      return;
    }
    if (currentUserStatus === StateStatus.NOT_INITIALIZED) {
      lastFetchedUserIdRef.current = userId;
      dispatch(getCurrentUserAccount(true));
    }
  }, [dispatch, isLoggedIn, userId, currentUserStatus]);

  useEffect(() => {
    const sourceLanguage = profileLanguage || cognitoLocale;
    if (!isLoggedIn || !sourceLanguage) {
      return;
    }
    const normalized = normalizeLanguage(sourceLanguage);
    if (i18n.language !== normalized) {
      i18n.changeLanguage(normalized);
    }
  }, [isLoggedIn, profileLanguage, cognitoLocale, i18n]);

  return null;
};

export default UserLanguageSync;
